import { Component, Inject, OnInit, inject, DestroyRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-instance-date-picker',
    templateUrl: './instance-date-picker.component.html',
    styleUrls: ['./instance-date-picker.component.scss'],
    standalone: false
})
export class InstanceDatePickerComponent  implements OnInit {
private destroyRef = inject(DestroyRef);
  startDate: Date;
  endDate: Date;
  initialStartDate: Date;
  initialEndDate: Date;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public matdialogRef: MatDialogRef<InstanceDatePickerComponent>) {
    
  }

  ngOnInit(): void {
    this.startDate = this.data.startDate;
    this.endDate = this.data.endDate;
    this.initialStartDate = this.data.startDate;
    this.initialEndDate = this.data.endDate;
  }
  
  startDateChange(event) {
    this.startDate = event.value;
  }

  endDateChange(event) {
    this.endDate = event.value;
  }

  applyFilter() {
    if (this.startDate && this.endDate) {
      this.matdialogRef.close({filteredStartDate: this.startDate, filteredEndDate: this.endDate});
    }
  }

  cancelFilter() {
    if (this.initialStartDate && this.initialEndDate) {
      this.matdialogRef.close({filteredStartDate: this.initialStartDate, filteredEndDate: this.initialEndDate});
    } else {
      this.matdialogRef.close(undefined);
    }
  }

  resetFilter() {
    this.startDate = undefined;
    this.endDate = undefined;
  }
}
